import { openAPIClient } from '../openApiClient';
import type {
  CreateQuizServiceConfig,
  DeleteQuizServiceConfig,
  GetQuizByIdServiceConfig,
  QuizByIdResponse,
  QuizCreateResponse,
  QuizListResponse,
  QuizListServiceConfig,
  QuizTranslateResponse,
  QuizUpdateResponse,
  TranslateQuizServiceConfig,
  UpdateQuizServiceConfig,
} from './types/index';

export async function getQuizListService({
  httpRequestConfig,
  params,
}: QuizListServiceConfig): Promise<QuizListResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.GET('/v1/auth/quiz/{spaceId}', {
    params: {
      path: {
        spaceId: httpRequestConfig.space,
      },
      query: params.query,
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function getQuizByIdService({
  httpRequestConfig,
  params,
}: GetQuizByIdServiceConfig): Promise<QuizByIdResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.GET('/v1/auth/quiz/{spaceId}/{id}/{quizLanguage}', {
    params: {
      path: {
        spaceId: httpRequestConfig.space,
        id: params.params.id,
        quizLanguage: params.params.quizLanguage,
      },
      query: params.query,
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function createQuizService({
  httpRequestConfig,
  params,
}: CreateQuizServiceConfig): Promise<QuizCreateResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.POST('/v1/auth/quiz/{spaceId}/{quizLanguage}', {
    params: {
      path: {
        spaceId: httpRequestConfig.space,
        quizLanguage: params.params.quizLanguage,
      },
    },
    body: params.body,
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function updateQuizService({
  httpRequestConfig,
  params,
}: UpdateQuizServiceConfig): Promise<QuizUpdateResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.PUT('/v1/auth/quiz/{spaceId}/{id}/{quizLanguage}', {
    params: {
      path: {
        spaceId: httpRequestConfig.space,
        id: params.params.id,
        quizLanguage: params.params.quizLanguage,
      },
      query: params.query,
    },
    body: params.body,
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function deleteQuizService({
  httpRequestConfig,
  params,
}: DeleteQuizServiceConfig): Promise<void> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.DELETE('/v1/auth/quiz/{spaceId}/{id}', {
    params: {
      path: {
        spaceId: httpRequestConfig.space,
        id: params.params.id,
      },
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }
}

export async function translateQuizService({
  httpRequestConfig,
  params,
}: TranslateQuizServiceConfig): Promise<QuizTranslateResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.POST('/v1/auth/quizActions/translateQuiz/{spaceId}/{id}', {
    params: {
      path: {
        spaceId: httpRequestConfig.space,
        id: params.params.id,
      },
      query: params.query,
    },
    body: params.body,
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}
